import { useTranslation } from "@rshbintech.dboul/utils";
import { AppLocale, TranslationNameSpace } from "../../common/types";

export const useAppTranslation = (nameSpace?: TranslationNameSpace) =>
  useTranslation<AppLocale, TranslationNameSpace>(nameSpace);
